import React from 'react';
import { Link } from 'react-router-dom';
import type { BlogPostListItemSchema } from '@/api/client';

interface Props {
  post: BlogPostListItemSchema;
}

function BlogCard({ post }: Props) {
  const date = post.published_at
    ? new Date(post.published_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <Link to={`/blog/${post.slug}`} className="blog-card">
      <h2 className="blog-card-title">{post.title}</h2>
      {post.excerpt && <p className="blog-card-excerpt">{post.excerpt}</p>}
      {date && <div className="blog-card-meta"><span>{date}</span></div>}
    </Link>
  );
}

export default BlogCard;
